import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class Importers extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Importers._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Importer Name",
				id: "importer_name",
				Cell: props => {
					return(
					<Link
						to={"/importers/" + props.original.binary_id + '-' + props.original.pkey}>{props.original.name}</Link>
					)

				}
			},

			{
				Header: "FFL",
				id: "ffl",
				/** @param {Importers_Object} obj */
				accessor: obj => (obj.ffl)
			},
			{
				Header: "Phone",
				id: "phone_number",
				/** @param {Importers_Object} obj */
				accessor: obj => (obj.phone_number)
			},
			{
				Header: "FFL Expiration",
				id: "ffl_expiration",
				/** @param {Importers_Object} obj */
				accessor: obj => {
					return obj.ffl_expiration ? moment(obj.ffl_expiration)
						.local()
						.format("MM/DD/YYYY") : ""
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/importers/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Importers', "")}
							{this.renderHeaderRight("Importers", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						className="-striped -highlight"

						pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
						renderPageSizeOptions={this.renderPageSizes}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
